import { useTranslation } from 'react-i18next'
import Layout from './Layout'

const PageError404 = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <h1>{t('label.not_found')}</h1>
    </Layout>
  )
}

export default PageError404
